import { NgModule } from '@angular/core';
import { CreatePwdComponent } from './create-pwd/create-pwd.component';
import { AboutComponent } from './about/about.component';
import { ProfessionComponent } from './profession/profession.component';
import { PhoneNumberComponent } from './phone-number/phone-number.component';
import { VerifyOtpComponent } from './verify-otp/verify-otp.component';

@NgModule({
  imports: [CreatePwdComponent, AboutComponent, VerifyOtpComponent, ProfessionComponent, PhoneNumberComponent],
  exports: [CreatePwdComponent, AboutComponent, VerifyOtpComponent, ProfessionComponent, PhoneNumberComponent],
})
export class RegisterModules {}
